import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import {
  ReactiveFormsModule,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { DialogRef } from "@angular/cdk/dialog";
import { HttpClient } from "@angular/common/http";

@Component({
  standalone: true,
  selector: "jnguyen-newsletter-dialog",
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: "./newsletter.component.html",
})
export class NewsletterDialogComponent {
  private dialogRef = inject(DialogRef<NewsletterDialogComponent>);
  private readonly http = inject(HttpClient);

  submitting = false;
  submitted = false;
  error = false;

  newsletterForm = new UntypedFormGroup({
    email: new UntypedFormControl("", [Validators.required, Validators.email]),
    firstName: new UntypedFormControl(""),
    lastName: new UntypedFormControl(""),
  });

  close(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (this.newsletterForm.invalid) {
      this.newsletterForm.markAllAsTouched();
      return;
    }

    this.error = false;
    this.submitting = true;

    this.http
      .post<{
        ok: boolean;
      }>("/.netlify/functions/subscribe-newsletter", this.newsletterForm.value)
      .subscribe({
        next: () => {
          this.newsletterForm.reset();
          this.submitted = true;
          this.submitting = false;
        },
        error: () => {
          this.error = true;
          this.submitting = false;
        },
      });
  }
}
